export const getHeadersWithToken = () => {
  const token = sessionStorage.getItem('accessToken');

  return {
    'Content-Type': 'application/json',
    Authorization: token || '',
  };
};
